module.exports = __webpack_public_path__ + "static/754b0c5f-9d57-4ca8-8c55-1b2fb9111057-8c6726e7bd6bfd49c66b212480946d67.jpeg";